import { useMemo } from 'react';
import { Child, useGetSinglePage } from 'react-easyrocket';
import { useLocation } from 'react-router';
import { SUPPORTED_LANGUAGES } from 'src/modules/locales/config';

type UseGetSeoPageData = () => Child | undefined;

export const useGetSeoPageData: UseGetSeoPageData = () => {
  const { childs } = useGetSinglePage('seo_pages');
  const { pathname } = useLocation();

  return useMemo(() => {
    const path = defineIsMainPage(pathname) ? '/main' : pathname;
    return (
      childs?.find((child) => {
        return path.includes(child.code.split('seo_')[1]);
      }) || childs?.find((child) => child.code === 'seo_main')
    );
  }, [childs, pathname]);
};

function defineIsMainPage(pathname: string) {
  const regexp = RegExp(
    `^/(${Object.keys(SUPPORTED_LANGUAGES)
      .map((l) => `${l}`)
      .join('|')})?/?$`
  );
  return regexp.test(pathname);
}
